export default "__VITE_ASSET__BbvdCC4S__"